var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginBoxLine = function SvgLoginBoxLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.111 15.346h1.833v4.583h11V5.262h-11v4.584H5.111v-5.5a.917.917 0 0 1 .917-.917H18.86a.916.916 0 0 1 .917.917v16.5a.916.916 0 0 1-.917.916H6.028a.917.917 0 0 1-.917-.916zm5.5-3.667v-2.75l4.583 3.667-4.583 3.666v-2.75H3.278V11.68z"
  })));
};
export default SvgLoginBoxLine;